var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2657_100704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.7197C15.4933 14.7197 15.04 14.9197 14.6933 15.233L9.94 12.4663C9.97333 12.313 10 12.1597 10 11.9997C10 11.8397 9.97333 11.6863 9.94 11.533L14.64 8.79301C15 9.12634 15.4733 9.33301 16 9.33301C17.1067 9.33301 18 8.43967 18 7.33301C18 6.22634 17.1067 5.33301 16 5.33301C14.8933 5.33301 14 6.22634 14 7.33301C14 7.49301 14.0267 7.64634 14.06 7.79967L9.36 10.5397C9 10.2063 8.52667 9.99967 8 9.99967C6.89333 9.99967 6 10.893 6 11.9997C6 13.1063 6.89333 13.9997 8 13.9997C8.52667 13.9997 9 13.793 9.36 13.4597L14.1067 16.233C14.0733 16.373 14.0533 16.5197 14.0533 16.6663C14.0533 17.7397 14.9267 18.613 16 18.613C17.0733 18.613 17.9467 17.7397 17.9467 16.6663C17.9467 15.593 17.0733 14.7197 16 14.7197Z",
    fill: "#454545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2657_100704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.8e4d75c2bd78b8d98608b2659313b99e.svg";
export { ForwardRef as ReactComponent };